// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PItalicOutlinedSvg from "@fishx/icons-svg/es/asn/PItalicOutlined";
import FishxIcon from '../components/FishxIcon';

var PItalicOutlined = function PItalicOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PItalicOutlinedSvg
  }));
};

PItalicOutlined.displayName = 'PItalicOutlined';
export default React.forwardRef(PItalicOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PItalicOutlined.js
// module id = 3467
// module chunks = 0